<template>
    <layout-vertical>

        <router-view :key="$route.name + ($route.params.id || '')" />

        <template #navbar="{ toggleVerticalMenuActive }">
            <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
        </template>

        <template v-slot:breadcrumb>
            <div>
                <app-breadcrumb />
            </div>
        </template>

        <template v-slot:footer>
            <p class="clearfix mb-0">
                <span class="float-md-left d-block d-md-inline-block mt-25">

                </span>

                <span class="float-md-right d-none d-md-block">
                    <b-link class="ml-25"
                            href="https://optify.dk"
                            target="_blank">Optify</b-link>
                </span>
            </p>
        </template>

    </layout-vertical>
</template>

<script>
    import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
    import Navbar from '../components/Navbar.vue'
    import AppBreadcrumb from '../components/AppBreadcrumb.vue'

    export default {
        components: {
            LayoutVertical,
            Navbar,
            AppBreadcrumb
        },
        data() {
            return {

            }
        },
    }
</script>
